import { AssociationRole } from '~~/openapi-client/gen/schemas'

export const RoleName: Record<AssociationRole, string> = {
	[AssociationRole.ADMIN]: 'Administrator',
	[AssociationRole.MANAGE_USERS]: 'Mitgliederverwalter',
	[AssociationRole.MEMBER]: 'Mitglied',
}

export const forbiddenRoleNames: string[] = [
	...Object.values(RoleName),
	'Vorstand',
	'Stellvertreter',
	'Stellvertreterin',
	'Mitgliederverwalterin',
]
